export interface IModule {
  brands: string
  customers: string
  employees: string
  invoices: string
  labels: string
  orders: string
  packaging: string
  premix: string
  products: string
  deliveryOrder: string
  salesReports: string
  salesOrders: string
  inventoryKosmetik: string
  inventoryOt: string
  production: string
  batch: string
  ingredient: string
  barangJadi: string
  purchaseOrder: string
  changelog: string
  statistics: string
}

export const modules = {
  brands: ['update', 'create'],
  customers: ['update', 'create', 'export'],
  employees: [
    'update',
    'create',
    'export',
    'salesReport',
    'createCheckin',
  ],
  invoices: ['update', 'export', 'queue', 'list'],
  labels: ['update', 'create', 'export'],
  orders: ['update', 'create', 'export', 'queue', 'list', 'packagingQueue'],
  packaging: ['update', 'create', 'request', 'requestList', 'export'],
  premix: ['update', 'create', 'request', 'requestList', 'export'],
  products: ['update', 'create', 'export', 'inventory', 'discounts'],
  deliveryOrder: ['queue', 'update', 'create', 'export'],
  salesReports: ['salesReport'],
  salesOrders: [
    'create',
    'updateLws',
    'updateOt',
    'factoryQueueLws',
    'factoryQueueOt',
    'readyQueueLws',
    'readyQueueOt',
    'export',
  ],
  inventoryKosmetik: [
    'inventoryPackaging',
    'inventoryPremix',
    'inventoryMixing',
    'inventoryFilling',
    'inventoryLabel',
    'inventorySetengahJadi',
    'inventoryJadi',
  ],
  inventoryOt: [
    'inventoryPackaging',
    'inventoryPremix',
    'inventoryMixing',
    'inventoryFilling',
    'inventoryLabel',
    'inventorySetengahJadi',
    'inventoryJadi',
  ],
  production: [
    'update',
    'create',
    'export',
    'productionFormListPremixKosmetik',
    'productionFormListPremixOt',
    'manageProductionFormHalfComplete',
    'createProductionFormPremix',
    'createProductionHalfComplete',
  ],
  batch: ['inventory', 'inventoryKosmetik', 'inventoryOt', 'create', 'export'],
  ingredient: ['request', 'requestList', 'create', 'update', 'inventory', 'export'],
  barangJadi: ['request', 'requestList'],
  purchaseOrder: ['list'],
  changelog: ['view'],
  statistics: ['view'],
} as const



export type Service = keyof typeof modules
export type Action = typeof modules[Service][number]

export const SERVICES = Object.fromEntries(
  Object.keys(modules).map((key) => [key, key])
) as { [K in Service]: K }

// Extract all unique actions into a constant object for easier access
const allActions = Array.from(new Set(Object.values(modules).flat()))
export const ACTIONS = Object.fromEntries(
  allActions.map((action) => [action, action])
) as { [K in Action]: K }

export const translations = {
  update: 'Pengaturan',
  updateSet: 'Pengaturan Set',
  updatePart: 'Pengaturan Part',
  create: 'Buat',
  queue: 'Antrian',
  list: 'Daftar',
  inventory: 'Stok',
  requestList: 'Daftar Request In/Out',
  discounts: 'Paket Diskon',
  request: 'Request',
  view: 'Lihat',
  export: 'Export',
  inventoryBahanBaku: 'Gudang Bahan Baku',
  inventoryPackaging: 'Gudang Kemasan',
  inventoryPackagingKosmetik: 'Gudang Kemasan (Kosmetik)',
  inventoryPackagingOt: 'Gudang Kemasan (OT)',
  inventoryPremix: 'Gudang Ruahan',
  inventoryPremixKosmetik: 'Gudang Ruahan (Kosmetik)',
  inventoryPremixOt: 'Gudang Ruahan (OT)',
  inventoryMixing: 'Gudang Mixing',
  inventoryFilling: 'Gudang Filling',
  inventoryLabel: 'Daftar Labeling',
  inventorySetengahJadi: 'Stok Setengah Jadi',
  inventoryJadi: 'Stok Barang Jadi',
  packagingQueue: 'Antrian Kemasan',
  visitForm: 'Formulir Kunjungan',
} as const

export const moduleTranslations = {
  brands: 'Merek',
  customers: 'Customer',
  deliveryOrder: 'Surat Jalan',
  invoices: 'Invoice',
  orders: 'Order',
  packaging: 'Kemasan',
  premix: 'Ruahan',
  products: 'Produk',
  salesOrders: 'Sales Order',
  employees: 'User',
  labels: 'Label',
  salesReports: 'Sales Report',
  inventoryKosmetik: 'Kosmetik',
  inventoryOt: 'OT',
  production: 'Produksi',
  batch: 'Batch',
  ingredient: 'Bahan Baku',
  purchaseOrder: 'Purchase Order',
  barangJadi: 'Barang Jadi',
  changelog: 'Log Audit',
  statistics: 'Statistik',
} as const
